import { discriminatedUnion, literal, number, object, string, any as zodAny } from 'zod';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { AwardType } from '@occc-app/offerHelpers/types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { IS_REQUIRED, isStringLengthUpTo } from '@occc-app/lib/constants/validationMessages';

import { referralCodePlaceholder, referralLinkPlaceholder } from './award-configuration.constants';

export const awardSchema = discriminatedUnion('type', [
  object({
    type: literal(AwardType.AwardNullable),
    points: zodAny().transform(() => null),
    voucheredOffer: zodAny().transform(() => null),
    voucheredOfferExpirationDays: zodAny().transform(() => null),
    voucherCount: zodAny().transform((): number | null => null),
  }).strict(),
  object({
    type: literal(AwardType.AwardPoints),
    points: number().int().positive(),
    voucheredOffer: zodAny().transform(() => null),
    voucheredOfferExpirationDays: zodAny().transform(() => null),
    voucherCount: zodAny().transform((): number | null => null),
  }).strict(),
  object({
    type: literal(AwardType.AwardVouchers),
    voucheredOffer: object(
      {
        id: string(),
        name: string(),
      },
      { message: IS_REQUIRED },
    ),
    voucheredOfferExpirationDays: number().int().positive().nullable().optional(), // .optional added because parseNumber util returns undefined as fallback
    voucherCount: number().int().positive().default(1),
    points: zodAny().transform(() => null),
  }).strict(),
]);

const getInstructionsSchema = (maxLength: number) =>
  string({ required_error: IS_REQUIRED })
    .trim()
    .min(1, IS_REQUIRED)
    .max(maxLength, isStringLengthUpTo(maxLength));

const smsTemplateInvalidMessage = `Please include ${referralLinkPlaceholder} and ${referralCodePlaceholder}`;

export const smsTemplateSchema = string({ required_error: IS_REQUIRED }).refine(
  (value) => {
    const referralLinkCount = (value.match(new RegExp(referralLinkPlaceholder, 'g')) || []).length;
    const referralCodeCount = (value.match(new RegExp(referralCodePlaceholder, 'g')) || []).length;

    return referralLinkCount > 0 && referralCodeCount > 0;
  },
  {
    message: smsTemplateInvalidMessage,
  },
);

export const senderConfigurationFormSchema = object({
  award: awardSchema,
}).strict();

export const receiverConfigurationFormSchema = object({
  award: awardSchema,
}).strict();

export const senderInstructionsSchema = getInstructionsSchema(10000);
export const receiverInstructionsSchema = getInstructionsSchema(200);
